<script lang="ts" setup>
import { onMounted } from 'vue'
import BaseInput from '~/components/common/base-input.vue'
import Datepicker from '@/components/common/datepicker.vue'
import { useLode } from '~/composables/lobby-games/use-lode'
import BaseDropdown from '~/components/common/base-dropdown.vue'
import { StringUtils } from '~/utils'
import LoadingSpin from '~common/loading-spin.vue'
import { useGames } from '~/composables/games/use-games'
import type { GameItem } from '~composables/lobby-games/interface'
import { DATE_TIME_FORMAT } from '~/constants'

const {
  probeNumber,
  lotteryFilter,
  currentDate,
  changeDate,
  regions,
  lotteryData,
  isLoading,
  guessNumbers,
  LODE_TABS,
  resetNumberDaily,
  changeRegion,
  changeSearchNumberTab,
  tabNumber
} = useLode()
const { playGame } = useGames()
defineProps({
  listGame: {
    type: Array<GameItem>,
    default: []
  }
})
onMounted(() => {
  resetNumberDaily()
})
</script>
<template>
  <section class="lo-de">
    <div class="lo-de__header">
      <div class="lo-de__header--filter">
        <div class="lo-de__header-left-panel d-flex">
          <div class="filter__date">
            <Datepicker
              :format="DATE_TIME_FORMAT.DATE_FORMAT_WITH_LOCAL_WEEK"
              :isRange="false"
              :isIconCalendar="false"
              placeholder="Chọn ngày"
              :disabledDates="currentDate"
              :defaultDate="lotteryFilter.date.toString()"
              @onSelectDate="changeDate"
            />
          </div>
          <div v-if="regions?.length" class="filter__select">
            <BaseDropdown
              :optionItems="regions"
              :valueSelected="lotteryFilter.region?.value?.toString()"
              @handleItemSelected="changeRegion"
            />
          </div>
        </div>
        <div class="lo-de__header-right-panel">
          <div class="filter__input">
            <BaseInput v-model="probeNumber" type="tel" :maxLength="6" placeholder="Nhập số dò" />
          </div>
        </div>
      </div>
    </div>
    <div class="lo-de__probe">
      <ul class="lo-de__probe--options">
        <li v-for="item in LODE_TABS" :key="item.key">
          <label>
            <input
              type="radio"
              name="searchBy"
              :value="item.value"
              @click="changeSearchNumberTab(item.value)"
              :checked="item.value === tabNumber"
              class="custom-radio__input"
            />
            <span class="custom-radio__pseudo"></span>
            <span>{{ item.label }}</span>
          </label>
        </li>
      </ul>
    </div>
    <div v-if="Object.values(lotteryData.lottery.result)?.length && !isLoading" class="lo-de__content">
      <div class="lo-de__result--special">
        <label>Giải Đặc Biệt</label>
        <div
          v-html="guessNumbers(StringUtils.splitStringAndWrap(lotteryData.lottery.result?.special, 'p'), true)"
        ></div>
      </div>
      <ul class="lo-de__result">
        <li>
          <label>Giải Nhất</label>
          <div v-html="guessNumbers(lotteryData.lottery.result?.prize1)"></div>
        </li>
        <li>
          <label>Giải Nhì</label>
          <div v-html="guessNumbers(lotteryData.lottery.result?.prize2)"></div>
        </li>
        <li>
          <label>Giải Ba</label>
          <div v-html="guessNumbers(lotteryData.lottery.result?.prize3)"></div>
        </li>
        <li>
          <label>Giải Tư</label>
          <div v-html="guessNumbers(lotteryData.lottery.result?.prize4)"></div>
        </li>
        <li>
          <label>Giải Năm</label>
          <div v-html="guessNumbers(lotteryData.lottery.result?.prize5)"></div>
        </li>
        <li>
          <label>Giải Sáu</label>
          <div v-html="guessNumbers(lotteryData.lottery.result?.prize6)"></div>
        </li>
        <li>
          <label>Giải Bảy</label>
          <div v-html="guessNumbers(lotteryData.lottery.result?.prize7)"></div>
        </li>
        <li v-if="lotteryData.lottery.result?.prize8 !== undefined && lotteryData.lottery.result?.prize8 !== ''">
          <label>Giải Tám</label>
          <div v-html="guessNumbers(lotteryData.lottery.result?.prize8)"></div>
        </li>
      </ul>
    </div>
    <div v-if="isLoading"><LoadingSpin /></div>
    <div v-if="!Object.values(lotteryData.lottery.result)?.length && !isLoading" class="lo-de__nodata">
      <img src="/assets/images/components/lobby-games/lode-nodata.png" alt="No data" />
      <div class="desc">Kết quả đang được cập nhật</div>
      <div
        class="lo-de__nodata-button button main main--primary cursor-pointer"
        @click="listGame.length && playGame(listGame[1])"
      >
        Đánh số ngay
      </div>
    </div>
  </section>
  <div v-if="Object.values(lotteryData.lottery.result)?.length" class="lo-de__button-container fixed-bottom">
    <div
      class="lo-de__button button main main--primary cursor-pointer"
      @click="listGame.length && playGame(listGame[1])"
    >
      Đánh số ngay
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/mobile/pages/lobby-games/section-lode.scss';
</style>
